import { doc, getDoc } from 'firebase/firestore';

import { throwErrorRollbar } from '..';
import { firestore } from '../Common/Firebase';

export const getChecklistById = async id => {
  try {
    const docRef = doc(firestore, 'Materials', id);
    const docSnap = await getDoc(docRef);
    const data = docSnap.data();

    if (data) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    console.error('error', error);
    error.name = 'error';
    throwErrorRollbar(error);
    throw error;
  }
};

export const checklistAPI = {
  getChecklistById,
};
